import {
	AddBlockingRuleLinkedItemsMutation,
	AddBlockingRuleLinkedLocationsMutation,
	AddPromotionRuleLinkedItemsMutation,
	AddPromotionRuleLinkedLocationsMutation,
	CreateBlockingRuleMutation,
	CreatePromotionRuleMutation,
	DeleteBlockingRuleMutation,
	DeletePromotionRuleMutation,
	RemoveBlockingRuleLinkedItemsMutation,
	RemoveBlockingRuleLinkedLocationsMutation,
	RemovePromotionRuleLinkedItemsMutation,
	RemovePromotionRuleLinkedLocationsMutation,
	UpdateBlockingRuleMutation,
	UpdatePromotionRuleMutation
} from "~/gql/mutations/restock/replenishmentRules.generated";
import {
	GetBlockingRuleQuery,
	GetPromotionRuleQuery,
	GetReplenishmentRuleGroupsQuery,
	GetReplenishmentRulesQuery
} from "~/gql/queries/restock/replenishmentRules.generated";

export const replenishmentRulesEndpoints = {
	AddBlockingRuleLinkedItems: {
		invalidatesTags: ["ReplenishmentRules"] as AddTagTypes,
		transformResponse: (res: AddBlockingRuleLinkedItemsMutation) => res
	},
	AddBlockingRuleLinkedLocations: {
		invalidatesTags: ["ReplenishmentRules"] as AddTagTypes,
		transformResponse: (res: AddBlockingRuleLinkedLocationsMutation) => res
	},
	AddPromotionRuleLinkedItems: {
		invalidatesTags: ["ReplenishmentRules"] as AddTagTypes,
		transformResponse: (res: AddPromotionRuleLinkedItemsMutation) => res
	},
	AddPromotionRuleLinkedLocations: {
		invalidatesTags: ["ReplenishmentRules"] as AddTagTypes,
		transformResponse: (res: AddPromotionRuleLinkedLocationsMutation) => res
	},
	CreateBlockingRule: {
		invalidatesTags: ["ReplenishmentRules"] as AddTagTypes,
		transformResponse: (res: CreateBlockingRuleMutation) => res
	},
	CreatePromotionRule: {
		invalidatesTags: ["ReplenishmentRules"] as AddTagTypes,
		transformResponse: (res: CreatePromotionRuleMutation) => res
	},
	DeleteBlockingRule: {
		invalidatesTags: ["ReplenishmentRules"] as AddTagTypes,
		transformResponse: (res: DeleteBlockingRuleMutation) => res
	},
	DeletePromotionRule: {
		invalidatesTags: ["ReplenishmentRules"] as AddTagTypes,
		transformResponse: (res: DeletePromotionRuleMutation) => res
	},
	GetBlockingRule: {
		providesTags: ["ReplenishmentRules"] as AddTagTypes,
		transformResponse: (res: GetBlockingRuleQuery) => res
	},
	GetPromotionRule: {
		providesTags: ["ReplenishmentRules"] as AddTagTypes,
		transformResponse: (res: GetPromotionRuleQuery) => res
	},
	GetReplenishmentRuleGroups: {
		providesTags: ["ReplenishmentRules"] as AddTagTypes,
		transformResponse: (res: GetReplenishmentRuleGroupsQuery) => res
	},
	GetReplenishmentRules: {
		providesTags: ["ReplenishmentRules"] as AddTagTypes,
		transformResponse: (res: GetReplenishmentRulesQuery) => res
	},
	RemoveBlockingRuleLinkedItems: {
		invalidatesTags: ["ReplenishmentRules"] as AddTagTypes,
		transformResponse: (res: RemoveBlockingRuleLinkedItemsMutation) => res
	},
	RemoveBlockingRuleLinkedLocations: {
		invalidatesTags: ["ReplenishmentRules"] as AddTagTypes,
		transformResponse: (res: RemoveBlockingRuleLinkedLocationsMutation) => res
	},
	RemovePromotionRuleLinkedItems: {
		invalidatesTags: ["ReplenishmentRules"] as AddTagTypes,
		transformResponse: (res: RemovePromotionRuleLinkedItemsMutation) => res
	},
	RemovePromotionRuleLinkedLocations: {
		invalidatesTags: ["ReplenishmentRules"] as AddTagTypes,
		transformResponse: (res: RemovePromotionRuleLinkedLocationsMutation) => res
	},
	UpdateBlockingRule: {
		invalidatesTags: ["ReplenishmentRules"] as AddTagTypes,
		transformResponse: (res: UpdateBlockingRuleMutation) => res
	},
	UpdatePromotionRule: {
		invalidatesTags: ["ReplenishmentRules"] as AddTagTypes,
		transformResponse: (res: UpdatePromotionRuleMutation) => res
	}
};
